import React, { createRef, useEffect } from 'react'
import './Messages.scss'
import { Link } from 'react-router-dom'
import { IMedia } from './useReadingAssessmentResponse'

export interface IUser {
    id: number
    name: string
    email: string
}

export interface IReference {
    // content: string
    book: {
        id: number
        file: IMedia
    }
    page_no: number
    content: string
}

export interface IMessage {
    author: IUser
    message: string
    references?: IReference[]
}

type Props = {
    messages: IMessage[]
    userID: number
    isAITyping: boolean
}

export default function Messages({ isAITyping, messages, userID }: Props) {
    const newMsgScrollPointRef = createRef<HTMLDivElement>()

    console.log(messages)

    useEffect(() => {
        newMsgScrollPointRef.current?.scrollIntoView()
    }, [messages, newMsgScrollPointRef])


    return (
        <div className="messages-container-wrapper">
            <div className='messages-container'>
                {messages.filter(m => m).map((m, index) => {
                    return <div key={index} className={m.author?.id === userID ? "current-user-message-bubble" : "peer-message-bubble"}>
                        <div className="msg-body">
                            <p>
                                {m.message}
                            </p>
                            <small className='references d-inline-block mt-3'>
                                <ol>
                                    {m.references?.map((ref, index) => {
                                        console.log(ref)
                                        let url = new URL(window.location.href.toString())
                                        url.searchParams.delete("page")
                                        url.searchParams.append("page", ref.page_no.toString())
                                        return <li key={index} className='c-pointer has-text-link' title={ref.content}>
                                            <Link className='d-inline-block' to={url.toString()}>
                                                {index + 1}. Page #{ref.page_no} {ref.book.file.name}
                                            </Link>
                                        </li>
                                    })}
                                </ol>
                            </small>
                        </div>
                    </div>
                })}
                {isAITyping && <div className="peer-message-bubble">
                    <div className="msg-body">
                        <div className="typing">
                            <div className="dot"></div>
                            <div className="dot"></div>
                            <div className="dot"></div>
                        </div>
                    </div>
                </div>}
                <div ref={newMsgScrollPointRef} />
            </div>
        </div>
    )
}